<template>
    <div v-if="componentData" class="small-wrapper grid two twoColumns">
        <h2>
            {{componentData.twoColumnsTitle}}
        </h2>
        <!-- <p>{{componentData.Content}}</p> -->

        <Markdown class="content" :source="componentData.Content" html breaks/>
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

import Markdown from 'vue3-markdown-it';

export default defineComponent({
    components:{
        Markdown
    },
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl
        };
    }
})

</script>
